import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { initialAgentsState } from "./agentsState";
import { AgentsStore } from "./agentsTypes";
import { createAgentsActions } from "./agentsActions";
import { createAgentsAsyncActions } from "./agentsAsyncActions";
import { createAgentDetailActions } from "./agentDetail/agentDetailActions";
import { createAgentDetailAsyncActions } from "./agentDetail/agentDetailAsyncActions";

export const createAgentsStore = (initialState = initialAgentsState) =>
    devtools<AgentsStore>(
        (set, get, store) => ({
            ...initialState,
            ...createAgentsActions(set, get, store),
            ...createAgentsAsyncActions(set, get, store),
            ...createAgentDetailActions(set, get, store),
            ...createAgentDetailAsyncActions(set, get, store),
        }),
        { name: "agents-store" }
    );

export const useAgentsStore = create<AgentsStore>()(createAgentsStore());
